// Chakra imports
import { Portal, Box, Button, useDisclosure } from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin.js";
// Layout components
import Navbar from "components/navbar/NavbarAdmin.js";
import Sidebar from "components/sidebar/Sidebar.js";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useState, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";
import { useLocation, useHistory } from "react-router-dom";
import useNodeTypes from "hooks/useNodeTypes";
import { useParams } from "react-router-dom";
import useRegenerateToken from "hooks/useRegenerateToken";

// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  // states and functions
  const location = useLocation();
  const [fixed] = useState(false);
  const history = useHistory();
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const tokenTimeOut = 60 * 29 * 1000;
  const { error, refetch } = useNodeTypes();
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const { mutate: regenerateToken } = useRegenerateToken(refetch);

  const Click = () => {
    localStorage.setItem("token", "random");
  };

  useEffect(() => {
    refetch();
  }, [window.location.pathname]);

  const name = useParams()?.name;

  useEffect(() => {
    getActiveRoute(routes);
  }, [location]);

  useEffect(() => {
    refetch();
  }, [localStorage.getItem("token")]);

  const getSecondryText = (routes) => {
    let activeRoute = ``;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.includes("schedule-downtime")) {
          return ``;
        }
        if (
          window.location.href.includes("entity") &&
          !window.location.href.includes("entity-dashboard")
        ) {
          return `Entity`;
        }
        if (window.location.href.includes("live-dashboard")) {
          return `Entity-${name}`;
        }
        if (window.location.href.includes("layout-planning")) {
          return `Entity-${name}`;
        }
        if (window.location.href.includes("client-dashboard")) {
          return ``;
        }
        if (window.location.href.includes("install-client")) {
          return `Install Client`;
        }
        if (window.location.href.includes("ticket-details")) {
          return `Ticket Management System`;
        }
        if (window.location.href.includes("node-dashboard")) {
          return `Home`;
        }
        if (window.location.href.includes("nonSync-dashboard")) {
          return ``;
        }
        if (window.location.href.includes("sla-report")) {
          return ``;
        }
        if (window.location.href.includes("entity-dashboard")) {
          return `${name}`;
        }
        if (window.location.href.includes("entity-client-list")) {
          return `Entity-${name}`;
        }
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getActiveRoute = (routes) => {
    let activeRoute = ``;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.includes("schedule-downtime")) {
          return "Schedule Downtime";
        }
        if (window.location.href.includes("live-dashboard")) {
          return `Live Dashboard`;
        }
        if (window.location.href.includes("layout-planning")) {
          return `Layout Planning`;
        }
        if (window.location.href.includes("sla-report")) {
          return `Reports`;
        }
        if (window.location.href.includes("node-dashboard")) {
          return `Node Dashboard`;
        }
        if (window.location.href.includes("install-client")) {
          return `Install Client`;
        }
        if (window.location.href.includes("entity-dashboard")) {
          return `Entity Dashboard`;
        }
        if (window.location.href.includes("entity-client-list")) {
          return `Entity Client List`;
        }
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();

  if (error && window.location.pathname !== "/admin/home") {
    if (error.response.data.message === "Token is invalid !!") {
      regenerateToken({
        refresh_token: localStorage.getItem("refresh_token"),
        email: localStorage.getItem("email"),
      });
      return;
      // localStorage.removeItem("token");
      // localStorage.removeItem("user");
      // history.push("/auth/sign-in");
    }
  }

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        {/* <Button onClick={Click}>cLICK</Button> */}
        <Sidebar
          routes={routes}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          display="none"
          {...rest}
        />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: isExpanded ? "100%" : "calc( 100% - 290px )" }}
          maxWidth={{
            base: "100%",
            xl: isExpanded ? "97%" : "calc( 100% - 290px )",
          }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText={"Horizon UI Dashboard PRO"}
                brandText={getActiveRoute(routes)}
                secondryText={getSecondryText(routes)}
                secondary={getActiveNavbar(routes)}
                message={getActiveNavbarText(routes)}
                isExpanded={isExpanded}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/" to="/admin/home" />
              </Switch>
            </Box>
          ) : null}
          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
